import { useState } from 'react';

/**
 * Custom hook for managing filter and sort states
 * Handles search queries and sort configurations
 */
export function useFilterSort() {
    // Left Pane Filter/Sort States
    const [searchQuery, setSearchQuery] = useState('');
    const [sortBy, setSortBy] = useState('name');
    const [sortOrder, setSortOrder] = useState('asc');

    // Latest Changes / Activity Feed Sort States
    const [activitySortBy, setActivitySortBy] = useState('date');
    const [activitySortOrder, setActivitySortOrder] = useState('desc');

    return {
        searchQuery,
        setSearchQuery,
        sortBy,
        setSortBy,
        sortOrder,
        setSortOrder,
        activitySortBy,
        setActivitySortBy,
        activitySortOrder,
        setActivitySortOrder
    };
}
